var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "card mt-3 bg-statusWarning" }, [
        _vm.apparatusHasMultipleSubscriptions &&
        _vm.premiumSubscriptionApparatusMultiplePlans &&
        (_vm.isSingleApparatusSubscription(
          _vm.premiumSubscriptionApparatusMultiplePlans.subscriptionProductId
        ) ||
          _vm.premiumSubscriptionApparatusMultiplePlans.apparatuses.length ===
            1)
          ? _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row mb-2" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "span",
                    {
                      staticClass: "mb-0 pb-0",
                      attrs: { "data-test-hook": "pageTitle" }
                    },
                    [
                      _c("i", {
                        staticClass: "far fa-triangle-exclamation pr-1",
                        attrs: { "data-test-hook": "titleIcon" }
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1rem",
                            "font-weight": "bold"
                          },
                          attrs: {
                            "data-test-hook":
                              "multiple-plans-account-needs-attention"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("xYourAccountNeedsAttentionHeader"))
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "row mb-2 ml-2" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "span",
                    {
                      attrs: {
                        "data-test-hook":
                          "apparatus-has-multiple-subs-body-text"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              "xApparatusHasMultipleSubsOnMobileBodyText1",
                              {
                                0: _vm.apparatusHasMultipleSubscriptions.name,
                                1: _vm.apparatusHasMultipleSubscriptions
                                  .preferredDealerName,
                                2: _vm.premiumSubscriptionApparatusMultiplePlans
                                  .subscriptionProductName,
                                3: _vm
                                  .$moment(
                                    _vm
                                      .premiumSubscriptionApparatusMultiplePlans
                                      .subscriptionRenewalDate
                                  )
                                  .format(_vm.$t("xShortDate"))
                              }
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "row mb-1 ml-2" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-warning btn-upgrade",
                      attrs: {
                        type: "button",
                        "data-test-hook": "openCancelPlanMultiplePlansBtn"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("openCancelPlanMultiplePlansModal")
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xCancelPlanLowercase")) + " ")]
                  )
                ])
              ])
            ])
          : _vm.apparatusHasMultipleSubscriptions &&
            _vm.premiumSubscriptionApparatusMultiplePlans &&
            _vm.isHomePremiumSubscription(
              _vm.premiumSubscriptionApparatusMultiplePlans
                .subscriptionProductId
            )
          ? _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row mb-2" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "span",
                    {
                      staticClass: "mb-0 pb-0",
                      attrs: { "data-test-hook": "pageTitle" }
                    },
                    [
                      _c("i", {
                        staticClass: "far fa-triangle-exclamation pr-1",
                        attrs: { "data-test-hook": "titleIcon" }
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1rem",
                            "font-weight": "bold"
                          },
                          attrs: {
                            "data-test-hook":
                              "multiple-plans-account-needs-attention"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("xYourAccountNeedsAttentionHeader"))
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "row mb-2 ml-2" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "span",
                    {
                      attrs: {
                        "data-test-hook":
                          "home-premium-apparatus-has-multiple-subs-body-text"
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("xAlreadyManagedPleaseRemoveApparatus", {
                              0: _vm.apparatusHasMultipleSubscriptions.name,
                              1: _vm.apparatusHasMultipleSubscriptions
                                .preferredDealerName,
                              2: _vm.getApparatusTypeAsString,
                              3: _vm.premiumSubscriptionApparatusMultiplePlans
                                .subscriptionProductName
                            })
                          ) +
                          " "
                      )
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "row mb-1 ml-2" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-warning btn-upgrade",
                      attrs: {
                        type: "button",
                        "data-test-hook": "openRemoveApparatusMultiplePlansBtn"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit(
                            "openRemoveApparatusMultiplePlansModal"
                          )
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("xRemoveFromPlan")) + " ")]
                  )
                ])
              ])
            ])
          : _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row mb-2" }, [
                _c("div", { staticClass: "col" }, [
                  _c(
                    "span",
                    {
                      staticClass: "mb-0 pb-0",
                      attrs: { "data-test-hook": "pageTitle" }
                    },
                    [
                      _c("i", {
                        staticClass: "far fa-triangle-exclamation pr-1",
                        attrs: { "data-test-hook": "titleIcon" }
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "1rem",
                            "font-weight": "bold"
                          },
                          attrs: {
                            "data-test-hook": "subscription-plan-details"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("xYourAccountNeedsAttentionHeader"))
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]),
              _c("div", { staticClass: "row mb-2 ml-2" }, [
                _c("div", { staticClass: "col" }, [
                  _vm.isOverLimit()
                    ? _c(
                        "span",
                        {
                          attrs: {
                            "data-test-hook":
                              "plan-cost-header-text-two-four-limit"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("xHomePremium2And4LimitText")) +
                              " "
                          )
                        ]
                      )
                    : (_vm.numberOfHsbApparatusesWithAttention?.length === 1 ||
                        _vm.productsOnBasicSubscription.length === 1) &&
                      _vm.numberOfFMApparatusesWithAttention == 0
                    ? _c(
                        "span",
                        {
                          attrs: {
                            "data-test-hook": "plan-cost-header-text-hsb-single"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("xYouHaveAHsbNotIncludedInAPlan")) +
                              " "
                          )
                        ]
                      )
                    : (_vm.numberOfHsbApparatusesWithAttention?.length > 1 ||
                        _vm.productsOnBasicSubscription.length > 1) &&
                      _vm.numberOfFMApparatusesWithAttention == 0
                    ? _c(
                        "span",
                        {
                          attrs: {
                            "data-test-hook":
                              "plan-cost-header-text-hsb-multiple"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("xYouHaveHsbsNotIncludedInAPlan")) +
                              " "
                          )
                        ]
                      )
                    : _vm.apparatusesNeedsAttention?.length == 1 ||
                      _vm.hasProductNotInPlan()
                    ? _c(
                        "span",
                        {
                          attrs: {
                            "data-test-hook": "plan-cost-header-text-single"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("xYouHaveAProductNotIncludedInAPlan")
                              ) +
                              " "
                          )
                        ]
                      )
                    : _c(
                        "span",
                        {
                          attrs: {
                            "data-test-hook": "plan-cost-header-text-multiple"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("xYouHaveProductsNotIncludedInAPlan")
                              ) +
                              " "
                          )
                        ]
                      )
                ])
              ]),
              _vm.isOverLimit()
                ? _c("div", { staticClass: "row mb-1 ml-2" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-warning btn-upgrade",
                          attrs: {
                            type: "button",
                            "data-test-hook": "openLearnMoreBtn"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openLearnMore()
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("xLearnMore")) + " ")]
                      )
                    ])
                  ])
                : _vm.isDifferentPlatform()
                ? _c("div", { staticClass: "ml-4" }, [
                    _vm.isAppleSub()
                      ? _c("div", { staticClass: "mt-4" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-test-hook": "manage-plan-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xManagePlanOnApple")) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://account.apple.com/account/manage/section/subscriptions",
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ml-3",
                                    attrs: {
                                      "data-test-hook": "manage-plan-text"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "https://account.apple.com/account/manage/section/subscriptions."
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      : _c("div", { staticClass: "mt-4" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    "data-test-hook": "manage-plan-text"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("xManagePlanOnGoogle")) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "row mb-3" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://play.google.com/store/account/subscriptions",
                                  target: "_blank"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ml-3",
                                    attrs: {
                                      "data-test-hook": "manage-plan-text"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          "https://play.google.com/store/account/subscriptions."
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                  ])
                : _c("div", { staticClass: "row mb-1 ml-2" }, [
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-warning btn-upgrade",
                          attrs: {
                            type: "button",
                            "data-test-hook":
                              "openSubscribePremiumMonitoringBtn",
                            disabled: _vm.disableUpgradeButton
                          },
                          on: {
                            click: function($event) {
                              return _vm.openSubscribePremium()
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.hasExistingPlanOnAccount()
                                  ? _vm.planHasRoom()
                                    ? _vm.$t("xUpdatePremiumPlan")
                                    : _vm.$t("xUpgradeNow")
                                  : _vm.$t("xUpgradePremium")
                              ) +
                              " "
                          )
                        ]
                      )
                    ])
                  ])
            ])
      ]),
      _c("PremiumEnrollmentBeforeYouUpgradeModal", {
        attrs: { apparatusesIncludedInUpgrade: _vm.apparatusesNeedsAttention },
        on: { openSubscriptionModal: _vm.openSubscriptionModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }